<!--
 * @Author: chj
 * @Date: 2024-10-10 15:34:47
 * @LastEditors: chj
 * @LastEditTime: 2024-10-22 10:17:04
 * @Description: 请填写简介
-->
<template>
  <footer :class="bem()">
    <div :class="bem('container')">
      <div :class="bem('container-left')">
        <p :class="bem('container-left-copyright')">智能互联生态联盟</p>
        <p :class="bem('container-left-line')">
          地址：北京市通州区观音庵南街1号院1号楼21层2单元2211
        </p>
        <p :class="bem('container-left-line')">邮编：101100</p>
        <p :class="bem('container-left-line')">联系电话：</p>
        <p :class="bem('container-left-line')">
          <a href="mailto:info@znhl.org.cn" target="_blank"
            >邮箱：info@znhl.org.cn</a
          >
        </p>
        <p :class="bem('container-left-line')">
          <a href="https://beian.miit.gov.cn/" target="_blank"
            >京ICP备17072405号-3</a
          >
        </p>
      </div>
      <div :class="bem('container-right')">
        <div :class="bem('container-right-item')">
          <div :class="bem('container-right-item-wrapper')">
            <img src="@/assets/images/gongzhonghao.jpg" alt="" />
          </div>
          <p :class="bem('container-right-item-title')">微信公众号</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "app-footer",
};
</script>

<style lang="scss" scoped>
.app-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 270px;
  background: #212121;
  @include devices(phone) {
    height: 420px;
  }
  &__container {
    width: 1440px;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    padding: 0 80px;
    @include devices(laptop) {
      width: 100%;
      padding: 0 40px;
    }
    @include devices(phone) {
      display: flex;
      flex-direction: column;
      padding: 0 20px;
    }
    &-left {
      &-copyright {
        font-weight: 500;
        font-size: 18px;
        line-height: 24px;
        color: #fff;
      }
      &-line {
        font-size: 14px;
        line-height: 20px;
        color: #fff;
        a {
          text-decoration: none;
          color: #fff;
        }
      }
    }
    &-right {
      display: flex;
      padding-top: 20px;
      &-item {
        width: 140px;
        height: 160px;
        margin-right: 20px;
        &:last-child {
          margin-right: 0;
        }
        &-wrapper {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 140px;
          height: 140px;
          background-color: #ffffff;
          img {
            width: 100%;
            height: 100%;
          }
        }
        &-title {
          font-size: 14px;
          line-height: 20px;
          color: #fff;
          text-align: center;
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
